import type { ETransportCustomerSubscriptionDto } from '@/generated/model';

export type SubscriptionStatusFilter = 'all' | 'active' | 'revoked';

const VAT_PATTERN = /^(?:[A-Z]{2}\d{1,18}|\d{1,20})$/;

export function getSubscriptionUnavailableReasonKey(reason: string | null | undefined) {
  switch (reason) {
    case 'RESPONSIBLE_CUSTOMER':
      return 'etransport.subscriptions.unavailable.responsiblecustomer';
    case 'ALREADY_ACTIVE':
      return 'etransport.subscriptions.unavailable.alreadyactive';
    case 'ALREADY_REVOKED':
      return 'etransport.subscriptions.unavailable.alreadyrevoked';
    case 'VAT_NOT_REGISTERED':
      return 'etransport.subscriptions.unavailable.vatnotregistered';
    case 'NO_ACTIVE_TOKEN':
      return 'etransport.subscriptions.unavailable.noactivetoken';
    default:
      return 'etransport.subscriptions.unavailable.unknown';
  }
}

export function normalizeVatInput(vat: string) {
  const normalizedVat = vat.replace(/\s+/g, '').toUpperCase();
  return normalizedVat.startsWith('RO') ? normalizedVat.slice(2) : normalizedVat;
}

export function isValidVatInput(vat: string) {
  return VAT_PATTERN.test(vat.replace(/\s+/g, '').toUpperCase());
}

export function filterSubscriptions(
  subscriptions: ETransportCustomerSubscriptionDto[],
  vatSearch: string,
  statusFilter: SubscriptionStatusFilter
) {
  const normalizedSearch = vatSearch.trim().toLocaleLowerCase();
  return subscriptions.filter((subscription) => {
    const active = subscription.revokedAtMicros == null;
    const matchesStatus = statusFilter === 'all' || (statusFilter === 'active' ? active : !active);
    const matchesVat =
      normalizedSearch === '' || (subscription.vat ?? '').toLocaleLowerCase().includes(normalizedSearch);
    return matchesStatus && matchesVat;
  });
}
